module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.433ac418.otf";